import React, {
  useEffect,
  useState
} from 'react';

import {
  fetchFavorites,
  removeFavorite
} from '../../services/userService';

function FavoritesPanel() {

  const [favorites, setFavorites] =
    useState([]);

  useEffect(() => {

    loadFavorites();

  }, []);

  const loadFavorites = async () => {

    try {

      const data =
        await fetchFavorites();

      setFavorites(data);

    } catch (error) {

    }
  };

  const handleRemove = async (
    propertyId
  ) => {

    try {

      await removeFavorite(
        propertyId
      );

      setFavorites((prev) =>
        prev.filter(
          (item) =>
            item.id !== propertyId
        )
      );

    } catch (error) {

    }
  };

  return (
    <div>

      <h2>
        علاقه‌مندی‌ها
      </h2>

      {favorites.map((item) => (

        <div
          key={item.id}
          className="favorite-card"
        >

          <h3>
            {item.title}
          </h3>

          <button
            onClick={() =>
              handleRemove(item.id)
            }
          >
            حذف
          </button>

        </div>

      ))}

    </div>
  );
}

export default FavoritesPanel;